module.exports = __webpack_public_path__ + "img/icon-confetti.fc3c0ba4.svg";